"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiTypographyThemeOptions = void 0;
const palette_1 = require("../../palette");
exports.MuiTypographyThemeOptions = {
    defaultProps: {
        variantMapping: {
            title: "h1",
            h1: "h1",
            h2: "h2",
            h3: "h3",
            h4: "h4",
            h5: "h5",
            mediumCaps: "h6",
            smallCaps: "h6",
            largeTextLabels: "span",
            regularTextParagraphs: "p",
            regularTextLabels: "span",
            smallTextLabels: "span",
            microText: "span",
        },
        variant: "regularTextParagraphs",
        color: palette_1.customColors.gray[90],
    },
};
